import React from "react";
import Sidebar from "../containers/Sidebar";
import Aside from "../style/Aside";

const SidebarBox = () => {
  return (
    <Aside>
      <Sidebar />
    </Aside>
  );
};

export default SidebarBox;
